<template>
  <div class="header" :class="headerType == 'ffffff' ? 'header-ffffff' : ''">
    <!-- 折叠按钮 -->
    <div
      v-show="headerType != 'ffffff'"
      :class="!collapse ? 'collapse-btn1' : 'collapse-btn2'"
      @click="collapseChage"
    >
      <!-- <i v-if="!collapse" class="el-icon-s-fold"></i>
      <i v-else class="el-icon-s-unfold"></i> -->
      <!-- <img src="@/assetc/img/nav_btn_type1.png" alt="" /> -->
    </div>
    <div
      v-show="headerType == 'ffffff'"
      :class="
        !collapse
          ? 'collapse-btn1 collapse-btn1s'
          : 'collapse-btn2 collapse-btn2s'
      "
      @click="collapseChage"
    ></div>
    <div class="logo">
      <div class="text">ELEPHANT</div>
    </div>
    <div class="header-right">
      <div class="header-user-con">
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip
            effect="dark"
            :content="fullscreen ? `Cancel full screen` : `Full screen`"
            placement="bottom"
          >
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <div class="user-avator">
          <div class="img"></div>
        </div>
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ username }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="xiala_btn-list">
            <!-- <el-dropdown-item divided command="editPassWord"
              >Change Password</el-dropdown-item
            > -->
            <el-dropdown-item divided command="loginout"
              >Log out
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="daping-dialog2">
      <el-dialog
        :destroy-on-close="true"
        :show-close="false"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="editPassShow"
        width="550px"
      >
        <editPass @newDialogFun="newDialogFun" v-if="editPassShow"></editPass>
      </el-dialog>
    </div>
  </div>
</template>
<script>
// 修改密码弹框
import editPass from '@/components/admin/editPass.vue';
import { logoutNew, editUserPassword } from '@/api';
import bus from '../common/bus';
export default {
  props: ['headerType'],
  components: {
    editPass,
  },
  data() {
    return {
      editPassShow: false,
      collapse: true,
      fullscreen: false,
      name: '',
      message: 2,
    };
  },
  computed: {
    username() {
      let username = localStorage.getItem('ms_username');
      return username ? username : this.name;
    },
    title() {
      return this.$route.meta.title;
    },
  },
  created() {
    let that = this;
    bus.$on('quanping', (msg) => {
      this.fullscreen = msg;
      this.$store.commit('headerModule/fullscreenFun', msg);
    });
    window.onkeydown = function (event) {
      if (event.keyCode === 122) {
        that.handleFullScreen();
        event.preventDefault();
        event.returnValue = false;
      }
    };
    // 路由拦截内触发，目的是路由变化隐藏导航后再将拆除按钮修改对应状态
    bus.$on('collapseBtnType', (msg) => {
      this.collapse = true;
    });
  },
  mounted() {
    // window.onresize = function () {
    //   var isFull =
    //     document.fullscreenElement ||
    //     document.mozFullScreenElement ||
    //     document.webkitFullscreenElement ||
    //     document.msFullscreenElement;
    //   if (isFull) {
    //     console.log('全屏');
    //   } else {
    //     console.log('没有全屏');
    //   }
    // };
  },
  methods: {
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      // 退出登录 loginout退出登录 editPassWord修改密码
      if (command == 'loginout') {
        // logoutNew({}).then((res) => {
        // if (res.data.result) {
        // } else {
        //   this.$globalProcessing.reportErrors.error(res.data.msg);
        // }
        localStorage.removeItem('ms_username');
        localStorage.removeItem('setMenus');
        localStorage.removeItem('token');
        localStorage.removeItem('id');
        localStorage.removeItem('userRole');
        this.$router.push('/login');
        // });
      } else if (command == 'editPassWord') {
        this.editPassShow = true;
      }
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
    // 全屏事件
    handleFullScreen(type) {
      let element = document.documentElement;
      if (this.fullscreen) {
        // if (document.exitFullscreen) {
        //   document.exitFullscreen();
        // } else if (document.webkitCancelFullScreen) {
        //   document.webkitCancelFullScreen();
        // } else if (document.mozCancelFullScreen) {
        //   document.mozCancelFullScreen();
        // } else if (document.msExitFullscreen) {
        //   document.msExitFullscreen();
        // }
        //退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        // if (element.requestFullscreen) {
        //   element.requestFullscreen();
        // } else if (element.webkitRequestFullScreen) {
        //   element.webkitRequestFullScreen();
        // } else if (element.mozRequestFullScreen) {
        //   element.mozRequestFullScreen();
        // } else if (element.msRequestFullscreen) {
        //   // IE11
        //   element.msRequestFullscreen();
        // }
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.msRequestFullscreen) {
          // 兼容ie11，11以下不支持
          element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) {
          // 兼容火狐
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
          // 兼容webkit内核浏览器，如chrome和safari
          element.webkitRequestFullscreen();
        } else {
          // 如果是ie10的话提示用户用f11进行全屏
          if (document.documentMode === 10) {
            alert('IE10无效，请使用F11进行全屏！');
          }
        }
      }
    },
    // 关闭修改密码
    newDialogFun() {
      this.editPassShow = false;
    },
  },
  mounted() {
    // console.log(this.$globalProcessing);
    // console.log(this.$router.currentRoute.query);
    // console.log('VueX', this.$store.state.sidebarModule.collapse);
    // this.$store.commit('sidebarModule/setCollapse', '777');
    // console.log('VueX', this.$store.state.sidebarModule.collapse);
    // if (document.body.clientWidth < 1500) {
    //   this.collapseChage();
    // }
  },
};
</script>
<style scoped lang="less">
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 80px !important;
  background-size: 100% 100%;
  font-size: 22px;
  color: #fff;
  // box-shadow: 0px 1px 0px 0px rgb(42 65 103 / 80%);
  position: relative;
  min-width: 1366px;
}
.collapse-btn1 {
  position: absolute;
  width: 32px;
  height: 29px;
  background: url('~@/assets/img/nav_btn_type2.png');
  background-size: 100% 100%;
  margin-top: 27px;
  margin-left: 28px;
  cursor: pointer;
}
.collapse-btn2s {
  background: url('~@/assets/img/nav_btn_type2s.png') !important;
  background-size: 100% 100% !important;
}
.collapse-btn1s {
  background: url('~@/assets/img/nav_btn_type1s.png') !important;
  background-size: 100% 100% !important;
}
.collapse-btn2 {
  position: absolute;
  width: 32px;
  height: 29px;
  background: url('~@/assets/img/nav_btn_type1.png');
  background-size: 100% 100%;
  margin-top: 27px;
  margin-left: 28px;
  cursor: pointer;
}
.header .logo {
  position: absolute;
  left: 125px;
  .text {
    font-size: 24px;
    letter-spacing: 4px;
    font-weight: bold;
    height: 80px;
    line-height: 80px;
  }
  .text::after {
    position: absolute;
    left: -35px;
    top: 0;
    bottom: 0;
    margin: auto;
    content: '';
    width: 40px;
    height: 2px;
    background-color: #adc5dc;
    transform: rotate(90deg);
    -webkit-transform: rotate(90deg);
    border-radius: 3px;
  }
  .fuhao {
    font-size: 24px;
    color: #ffd200;
    margin-top: 12px;
    line-height: 100%;
    letter-spacing: 6px;
    .left {
      padding-right: 8px;
      -webkit-background-clip: text;
      color: transparent;
      background-image: linear-gradient(
        90deg,
        rgba(255, 210, 0, 0.17) 35%,
        rgba(255, 210, 0, 1) 52%
      );
      letter-spacing: -3px;
    }
    .right {
      padding-left: 8px;
      -webkit-background-clip: text;
      color: transparent;
      background-image: linear-gradient(
        270deg,
        rgba(255, 210, 0, 0.17) 35%,
        rgba(255, 210, 0, 1) 52%
      );
      letter-spacing: -3px;
    }
  }
  img {
    height: 32px;
    width: auto;
    position: absolute;
    left: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }
}
.header-right {
  float: right;
  padding-right: 50px;
}
.header-user-con {
  display: flex;
  height: 80px;
  align-items: center;
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.user-name {
  margin-left: 5px;
  font-size: 16px;
}
.user-avator {
  margin-left: 20px;
  width: 44px;
  height: 44px;
  background: #3767fb;
  border-radius: 50%;
  position: relative;
  .img {
    display: block;
    width: 25px;
    height: 22px;
    background: url('~@/assets/img/ricon11.png');
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: center;
}
</style>
